import hasFullName from './utilities/hasFullName';
import hasTrainingTracker from './utilities/hasTrainingTracker';

const userContext = (userContextJson) => {
  const properties = {
    ...userContextJson,
    guid: userContextJson.userGuid,
  };
  return Object.assign(
    properties,
    hasFullName(userContextJson),
    { trainingTracker: userContextJson.trainingTracker ? hasTrainingTracker(userContextJson.trainingTracker): null },
  );
};

export default userContext;
